import apontamentoColetasLocalizacaoReport from "entity/Indicador/reports/ApontamentoColetasLocalizacaoReport";
import apontamentoHeaderLocalizacaoReport from "entity/Indicador/reports/ApontamentoHeaderLocalizacaoReport";
import apontamentoImagesReport from "entity/Indicador/reports/ApontamentoImagesReport";
import apontamentoObservacaoReport from "entity/Indicador/reports/ApontamentoObservacaoReport";
import apontamentoPontosAmostradosReport from "entity/Indicador/reports/ApontamentoPontosAmostradosReport";
import TableReportHelper from "report/helper";

export default async function dcReport(indicador, visita) {
    const h = new TableReportHelper(visita.data);
    const IndicadorClass = indicador.constructor;

    const apontamentos = visita.getApontamentosByIndicador(indicador);

    const content = [];

    for (const apontamento of apontamentos) {
        const params = visita.cliente.getParams(IndicadorClass, apontamento.tipo, indicador.type);
        const paramItems = visita.cliente.getParamItems(IndicadorClass, apontamento.tipo);
        const additionalColumn = {
            label: "Operador",
            field: "operador.operador",
            width: "*",
        };
        content.push([
            await apontamentoHeaderLocalizacaoReport(
                visita,
                indicador,
                apontamento,
                params,
                undefined,
                undefined,
                additionalColumn,
            ),

            await apontamentoColetasLocalizacaoReport(
                visita,
                indicador,
                apontamento,
                ["Espaçamento", "Conforme"],
                // prettier-ignore
                (h) => [
                    h.numberField("espacamento"),
                    h.textField("conforme"),
                ],
                [60, 60],
            ),
            apontamentoPontosAmostradosReport(visita, indicador, apontamento, paramItems, "cm"),
            apontamentoImagesReport(visita, indicador, apontamento),
            apontamentoObservacaoReport(visita, indicador, apontamento),

            h.space(),
        ]);
    }

    return content;
}
